module.exports = __webpack_public_path__ + "media/media/logos/smrp-2278aa24a7de3bf108fda22422f92513.png";